import apiFetch from '../apiFetch'

export default function (token, organizedUnitId, repairShopId) {
  return apiFetch({ endPoint: `Repairshop/${organizedUnitId}/${repairShopId}`, method: 'GET', token: token })
}
